import { Injectable } from '@angular/core';
import { Chip, Taxonomies, StoreName } from '@app/constants';
import { Subject, BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TaxonomyStoreService } from './taxonomy-store.service';

interface UpateFacets {
  facets: Array<any>;
  queryParams:  Array<any>;
}

@Injectable({
  providedIn: 'root'
})
export class FacetsService {

  private updateFacets$ = new BehaviorSubject({facets: Array<any>(), queryParams: Array<any>()});
  
  public taxonomy$ = this.taxonomyStore.taxonomy$;
  public facets$;

  constructor(
    private taxonomyStore: TaxonomyStoreService
  )
  {
    this.facets$ = combineLatest([
        this.taxonomy$,
        this.updateFacets$
      ]).pipe(
      tap(_ => console.log('FacetsService _ ', _)),
      map(([chips, updateFacets]) => {

        const allFacets = new Map<string, Taxonomies[]>();

        updateFacets.facets.map((section: any): any => {

          let facetsGroup = section.name;
          const queryParams = updateFacets.queryParams;
          let facets: Taxonomies[] = [];

          //console.log('FacetsService route ', route);
          //console.log('FacetsService section ', section);
          //console.log('FacetsService facetsGroup ', facetsGroup);

          section.values.map((facet: any) => {
            //console.log('FacetsService setFacets facet ', facet);

            if (facet.count > 0) {
              const chip = this.taxonomyStore.getEntity(facetsGroup, facet.filter);
              //console.log('FacetsService setFacets chip ', chip);

              let normalizedFacet: any = false;

              if (chip !== undefined) {
                
                //facetsGroup = facetsGroup === 'field_partners' ? 'partneri' : facetsGroup === 'field_school' ? 'skoly' : facetsGroup;

                const populatedChip = {
                  ...chip,
                  facetsGroup,
                  facetName: chip!.entityUrl!.path,
                  queryParams
                };

                const selected: boolean = this.isInQueryParams(populatedChip);

                normalizedFacet = {
                  ...facet,
                  ...chip,
                  selected,
                  facetsGroup
                };

                normalizedFacet.queryParams = this.getFacetsQueryParams(normalizedFacet, queryParams);

                facets.push(normalizedFacet)
              }
            }
          })
          allFacets.set(facetsGroup, facets);
        })
        return allFacets;
      }),
      //tap(_ => console.log('FacetsService _ ', _)),
    );
  }

  public setFacets = (facets: any[], queryParams: any[]) => {
    //console.log('FacetsService setFacets facets ', facets);
    //console.log('FacetsService setFacets this.routeQuery.getQueryParams() ', this.routeQuery.getValue().queryParams);

    this.updateFacets$.next({facets, queryParams});
  }

  public getFacets$ = (chips: string[]): Observable<Taxonomies[]> => this.taxonomyStore.getTaxonomyEntities$(chips);
  public getEntity = (id: string): Taxonomies => this.taxonomyStore.getTaxonomyEntity(id);

  //public getAllFacets$ = (): any => this.facets$;

  public getChips = (storeName: string, ids: any): Chip[] => this.taxonomyStore.getEntities(storeName, ids);

  public getFacetsQueryParams = (facet: any, queryParams: any) => {
    //console.log('FacetsService getFacetsQueryParams facet ', facet);

    if (facet && facet.facetsGroup !== undefined) {
      const taxonomySwitch = facet.facetsGroup;
      //const queryParams = this.queryParams;

      //console.log('FacetsService getFacetsQueryParams queryParams ', queryParams);


      let newQueryParams: any = {...queryParams};

      // pager

      if(newQueryParams.strana) {
        delete newQueryParams.strana;
      }

      // fulltext
      if (facet.facetsGroup === 'text') {

        if (newQueryParams.text) {
          delete newQueryParams.text;
        }
      }
      else {

        let path: string;

        path = facet.url;

        /*facet!.entityUrl!.path!;

        path = taxonomySwitch === 'stitky' ? path.split('/')[2] : path;*/

        /* anomalias ????? */
        if (path === 'otazky-odpovedi') {
          path = 'otazky-a-odpovedi';
        }

        let tags = queryParams[taxonomySwitch] === undefined ? [] : queryParams[taxonomySwitch];

        tags = Array.isArray(tags) ? tags : [tags];

        let newTags = [];

        if (!facet.selected) {

           newTags = [...tags, path];
        }

        else if (tags.length > 0 && tags.includes(path)) {
          newTags = tags.filter((tag: string) => tag !== path);
        }

        newQueryParams[taxonomySwitch] = newTags;
      }

      //console.log('FacetsService getFacetsQueryParams newQueryParams ', newQueryParams);
      return newQueryParams;
    }
    else {
      return false;

    }
    
  }

  
  /* private */

  private isArray = (obj : any ) => Array.isArray(obj);

  private isInQueryParams = (facet : any) => {

    const queryParams = facet.queryParams;

    //console.log('FacetsService setFacets facet ', facet);
    //console.log('FacetsService setFacets queryParams ', queryParams);

    if (queryParams[facet.facetsGroup]) {

      if (this.isArray(queryParams[facet.facetsGroup]) && queryParams[facet.facetsGroup].includes(facet.facetName)) {
        return true;
      }
      else if (queryParams[facet.facetsGroup] === facet.facetName) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }
}
